import { Badge } from "@/components/ui/badge";
import { SheetTrigger } from "@/components/ui/sheet";

interface FloatingCartButtonProps {
  itemCount: number;
}

/**
 * FloatingCartButton Component
 * Floating action button that opens the cart
 * Shows badge with item count when cart has items
 */
export function FloatingCartButton({ itemCount }: FloatingCartButtonProps) {
  return (
    <SheetTrigger asChild>
      <button
        className="bg-brand-600 fixed right-5 bottom-5 z-999 flex h-12 w-12 cursor-pointer items-center justify-center rounded-full p-3 text-lg shadow-lg transition-all duration-300 ease-in-out hover:scale-[1.08] hover:shadow-xl"
        aria-label="Open shopping cart"
      >
        <i className="ri-shopping-cart-line text-white"></i>
        {itemCount > 0 && (
          <Badge className="bg-brand-500 absolute -top-1 -right-1 flex h-5 w-5 items-center justify-center rounded-full border-2 border-white p-0 text-xs font-light text-white">
            {itemCount > 99 ? "99+" : itemCount}
          </Badge>
        )}
      </button>
    </SheetTrigger>
  );
}
